import styled from 'styled-components'

export const DealStatsContainer = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}
    border: var(--dashboard-default-border);
    border-radius: var(--dashboard-border-radius);
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: space-around;
    background-color: var(--dashboard-basic-background-color);
    label {
        width: 150px;
        font-size: 16px;
        line-height: 18px;
        text-align: left;
        padding: var(--dashboard-default-gap);
        color: var(--dashboard-main-color);
    }
    .stat {
        padding: 0 10px;
        flex-grow: 1;
        border-right: var(--dashboard-default-border);
        strong {
            font-size: 28px;
            font-weight: bold;
            display: block;
            color: var(--dashboard-black-color);
        }
        span {
            font-size: 11px;
            color: var(--dashboard-black-color);
        }
        &:last-child {
            border-right: none;
        }
    }
    &:hover {
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
    animation: fadeIn 0.3s ease-in-out;
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translate(0, -20px);
        }
        to {
            opacity: 1;
            transform: translate(0, 0);
        }
    }
`
